import { defineComponent as _defineComponent } from 'vue'

import type { ExternalReference } from '@ilteducation/exercise-service-types';

type Props = {
  item: ExternalReference;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowExternalReference',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: ExternalReference;
}



return { __sfc: true,props }
}

})